import { useState, useCallback } from 'react';

export const useTimelineSelection = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleTimelineItemClick = useCallback((item) => {
    setSelectedItem(item);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedItem(null);
  }, []);

  return {
    selectedItem,
    handleTimelineItemClick,
    clearSelection
  };
};